var React = require('react');

function IconCardShow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M118.1 576.6h308.8c11 0 20 9 20 20V813c0 11-9 20-20 20H118.1c-11 0-20-9-20-20V596.6c0-11 9-20 20-20zM597 190h308.8c11 0 20 9 20 20v216.4c0 11-9 20-20 20H597c-11 0-20-9-20-20V210c0-11 9-20 20-20zM119.3 191.8h308.8c11 0 20 9 20 20v216.4c0 11-9 20-20 20H119.3c-11 0-20-9-20-20V211.8c0-11 9-20 20-20zM595.8 574.8h308.8c11 0 20 9 20 20v216.4c0 11-9 20-20 20H595.8c-11 0-20-9-20-20V594.8c0-11 9-20 20-20z"}));
}

IconCardShow.displayName = "IconCardShow";

IconCardShow.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCardShow;

IconCardShow.default = IconCardShow;
